function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.1912 22.1999V26.3999H21.4812C20.2215 26.3999 19.2012 27.4739 19.2012 28.7999V40.8C19.2012 42.126 20.2215 43.1999 21.4812 43.1999H39.721C40.9806 43.1999 42.0012 42.126 42.0012 40.8V28.7999C42.0012 27.4739 40.9806 26.3999 39.721 26.3999H38.0112V22.1999C38.0112 17.892 34.6935 14.3999 30.6012 14.3999C26.5088 14.3999 23.1912 17.892 23.1912 22.1999ZM26.0412 26.3999V22.1999C26.0412 19.548 28.0817 17.3998 30.6011 17.3998C33.1205 17.3998 35.1611 19.548 35.1611 22.1999V26.3999H26.0412ZM28.3211 32.9999C28.3211 31.674 29.3414 30.6 30.6011 30.6C31.8608 30.6 32.881 31.674 32.881 32.9999C32.881 33.846 32.4648 34.5901 31.838 35.0161C31.838 35.0161 32.0607 36.4323 32.3112 38.1C32.3112 38.5979 31.9293 38.9998 31.4562 38.9998H29.7461C29.273 38.9998 28.8912 38.5979 28.8912 38.1L29.3643 35.0161C28.7374 34.5901 28.3211 33.846 28.3211 32.9999Z",
  fill: "white"
});

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.c767c90b.svg";
export { ForwardRef as ReactComponent };